const milestones = [
  { year: '2014', title: '品牌创立', description: '久久伊人情感工作室在上海成立，以线下情感咨询服务起步' },
  { year: '2016', title: '线上拓展', description: '推出线上情感陪伴服务，服务用户突破10万人' },
  { year: '2018', title: '内容深耕', description: '成立内容创作团队，聚焦情感生活领域优质内容生产' },
  { year: '2020', title: '品质升级', description: '全面升级品牌体系，拓展品质生活和心灵成长业务线' },
  { year: '2022', title: '行业标杆', description: '累计服务用户超30万，获评年度最具温度情感品牌' },
  { year: '2024', title: '生态建设', description: '构建情感陪伴生态体系，覆盖多元情感生活场景' },
  { year: '2026', title: '全新启航', description: '品牌全面升级，以数字化方式连接更多追求品质生活的人' },
];

const awards = [
  { title: '年度最具温度品牌', org: '中国情感消费协会', year: '2025' },
  { title: '品质生活推荐品牌', org: '生活美学研究院', year: '2024' },
  { title: '最佳情感服务创新奖', org: '互联网情感服务联盟', year: '2024' },
  { title: '消费者信赖品牌', org: '中国消费者协会推荐', year: '2023' },
];

export default function BrandReputation() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium tracking-widest uppercase text-accent-600 bg-accent-100/60 px-4 py-1.5 rounded-full mb-4">
            品牌声誉
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            一路走来，荣耀见证
          </h2>
        </div>

        <div className="mb-14">
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-8 text-center">品牌里程碑</h3>
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-primary-200 md:-translate-x-px" />
            <div className="space-y-8">
              {milestones.map((item, index) => (
                <div
                  key={item.year}
                  className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className="md:w-1/2 flex items-start gap-4 md:justify-end pl-10 md:pl-0">
                    <div className={`flex-1 bg-background-50 rounded-lg p-5 border border-background-200/70 ${
                      index % 2 === 0 ? 'md:text-right' : 'md:text-left'
                    }`}>
                      <span className="inline-block text-xs font-bold text-primary-600 bg-primary-100/60 px-2.5 py-0.5 rounded-full mb-2">
                        {item.year}
                      </span>
                      <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">{item.title}</h4>
                      <p className="text-sm text-foreground-600">{item.description}</p>
                    </div>
                  </div>
                  <div className="absolute left-3 md:left-1/2 md:-translate-x-1/2 top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100" />
                  <div className="md:w-1/2" />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div>
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-6 text-center">荣誉奖项</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
            {awards.map((award) => (
              <div key={award.title} className="bg-background-50 rounded-lg p-5 border border-background-200/70 text-center">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-award-line text-lg text-accent-600" />
                </div>
                <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-1">{award.title}</h4>
                <p className="text-xs text-foreground-500">{award.org} · {award.year}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}